/**
 * Created by yihong on 1/15/18.
 */
export const ACTION_GET_USER_INFO = 'ACTION_GET_USER_INFO'　//获取ticket后发出信息，用于调用接口获取用户信息

export const PAGE_CREATE = 'PAGE_CREATE'; // HOMEPAGE CREATED时发出　用来调用接口，不要用于dom操作

export const USRE_INFO_LOAD = 'USRE_INFO_LOAD'; //用户信息加载完成


//获取抽奖记录　中奖记录弹窗展示时刷新　或者在中奖记录的弹窗中提交信息时刷新
export const GET_LOTTERY_HISTORY = 'GET_LOTTERY_HISTORY';
export const ADD_LOTTERY_CHANCE = 'ADD_LOTTERY_CHANCE'
export const GET_REMAIN_TIMES = 'GET_REMAIN_TIMES'


//投票
export const GET_VOTE_REMAIN_TIMES = 'GET_VOTE_REMAIN_TIMES'; //获取投票次数
export const GET_VOTE_CHAR_LIST = 'GET_VOTE_CHAR_LIST'; //获取候选人信息一场
export const SIGN_FOR_VOTE = 'SIGN_FOR_VOTE'; //投票签到送票
export const VOTE_FOR_CHAR = 'VOTE_FOR_CHAR'; //投票



// WEBPACK FOOTER //
// ./src/constant/eventbus.js